<template>
    <div class="content container-fluid">
        <!-- Page Header -->
        <div class="page-header">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="page-title">{{ role == 'admin' ? '' : 'My Staff ' }}Monthly Car Park Claim Report</h3>
                </div>
            </div>
        </div>
        <!-- /Page Header -->

        <!-- Form -->
        <form @submit.prevent="search">
            <div class="row align-items-center">
                <div class="col-md-2">Company</div>
                <div class="col-md-4 pl-md-0">
                    <select class="custom-select" v-model="company">
                        <option v-for="(item, i) in companies" :key="i" :value="item.CompanyName">
                            {{ item.CompanyName }}
                        </option>
                    </select>
                </div>
                <div class="col-md-2 ml-md-4">Department</div>
                <div class="col-md-3 pl-md-0">
                    <select class="custom-select" v-model="department">
                        <option value="">All</option>
                        <option v-for="item in departments" :key="item.Department" :value="item.Department">
                            {{ item.Department }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="row align-items-center mt-2">
                <div class="col-md-2">Approved Date From</div>
                <div class="col-md-4 pl-md-0">
                    <input type="date" class="form-control" v-model="approvedDateFrom" required />
                </div>
                <div class="col-md-2 ml-md-4">Approved Date To</div>
                <div class="col-md-3 pl-md-0">
                    <input type="date" class="form-control" v-model="approvedDateTo" :min="approvedDateFrom" required />
                </div>
            </div>

            <div class="row align-items-center mt-2">
                <div class="col-md-2">Car park claim Month / Year From</div>
                <div class="col-md-4 pl-md-0">
                    <div class="row">
                        <div class="col-md-6">
                            <select class="custom-select" v-model="monthFrom" required>
                                <option value="1">Jan</option>
                                <option value="2">Feb</option>
                                <option value="3">Mar</option>
                                <option value="4">Apr</option>
                                <option value="5">May</option>
                                <option value="6">Jun</option>
                                <option value="7">Jul</option>
                                <option value="8">Aug</option>
                                <option value="9">Sep</option>
                                <option value="10">Oct</option>
                                <option value="11">Nov</option>
                                <option value="12">Dec</option>
                            </select>
                        </div>

                        <div class="col-md-6">
                            <select class="custom-select" v-model="yearFrom" required>
                                <option v-for="year in years" :key="year" :value="year">
                                    {{ year }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="col-md-2 ml-md-4">Car park claim Month / Year To</div>
                <div class="col-md-3 pl-md-0">
                    <div class="row">
                        <div class="col-md-6">
                            <select class="custom-select" v-model="monthTo" required>
                                <option value="1">Jan</option>
                                <option value="2">Feb</option>
                                <option value="3">Mar</option>
                                <option value="4">Apr</option>
                                <option value="5">May</option>
                                <option value="6">Jun</option>
                                <option value="7">Jul</option>
                                <option value="8">Aug</option>
                                <option value="9">Sep</option>
                                <option value="10">Oct</option>
                                <option value="11">Nov</option>
                                <option value="12">Dec</option>
                            </select>
                        </div>

                        <div class="col-md-6">
                            <select class="custom-select" v-model="yearTo" required>
                                <option v-for="year in years" :key="year" :value="year">
                                    {{ year }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row align-items-center mt-2">
                <div class="col-md-2">Job Grade</div>
                <div class="col-md-4 pl-md-0">
                    <select class="custom-select" v-model="jobGrade">
                        <option value="">All</option>
                        <option v-for="item in jobGrades" :key="item.JobGrade" :value="item.JobGrade">
                            {{ item.JobGrade }}
                        </option>
                    </select>
                </div>
                <div class="col-md-2 ml-md-4">Cost Centre</div>
                <div class="col-md-3 pl-md-0">
                    <select class="custom-select" v-model="costCentre">
                        <option value="">All</option>
                        <option v-for="item in costCentres" :key="item.CostCentre" :value="item.CostCentre">
                            {{ item.CostCentre }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="row align-items-center mt-2">
                <div class="col-md-2">Manager</div>
                <div class="col-md-4 pl-md-0">
                    <select class="custom-select" v-model="managerId" v-if="role == 'admin'">
                        <option value="">All</option>
                        <option v-for="item in managers" :key="item.id" :value="item.id">
                            {{ item.text }}
                        </option>
                    </select>
                    <span v-else>{{ managers.length ? managers[0].text : "" }}</span>
                </div>
                <div class="col-md-2 ml-md-4">Designation</div>
                <div class="col-md-3 pl-md-0">
                    <select class="custom-select" v-model="designation">
                        <option value="">All</option>
                        <option v-for="item in designations" :key="item.Designation" :value="item.Designation">
                            {{ item.Designation }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="row align-items-center mt-2">
                <div class="col-md-2">Employee Name/ID</div>
                <div class="col-md-4 pl-md-0">
                    <Select2 v-model="userId" :options="employees" v-if="role == 'admin' || isManager" />
                    <span v-else>{{ employees.length ? employees[0].text : "" }}</span>
                </div>
                <div class="col-md-2 ml-md-4">
                    <button type="submit" class="btn btn-primary">Search</button>
                </div>
            </div>
        </form>
        <!-- /Form -->

        <!-- Pagination -->
        <div class="row mt-4 align-items-center" v-if="records && records.length">
            <div class="col-md-6">
                Show
                <select class="custom-select" v-model="paging.SizePerPage" style="width: 5em">
                    <option v-for="item in paging.Sizes" v-bind:key="item" v-bind:value="item">
                        {{ item }}
                    </option>
                </select>
                entries
            </div>
            <div class="col-md-6 text-right">
                <form :action="backendUrl + '/CarparkClaimExcelReport/ExportExcel'" method="POST">
                    <input type="hidden" name="Company" :value="companyForExcel" />
                    <input type="hidden" name="Department" :value="departmentForExcel" />
                    <input type="hidden" name="ApprovedDateFrom" :value="approvedDateFromExcel" />
                    <input type="hidden" name="ApprovedDateTo" :value="approvedDateToExcel" />
                    <input type="hidden" name="MonthFrom" :value="monthFromExcel" />
                    <input type="hidden" name="MonthTo" :value="monthToExcel" />
                    <input type="hidden" name="YearFrom" :value="yearFromExcel" />
                    <input type="hidden" name="YearTo" :value="yearToExcel" />
                    <input type="hidden" name="JobGrade" :value="jobGradeExcel" />
                    <input type="hidden" name="CostCentre" :value="costCentreExcel" />
                    <input type="hidden" name="ManagerId" :value="managerIdExcel" />
                    <input type="hidden" name="Designation" :value="designationExcel" />
                    <input type="hidden" name="UserId" :value="userIdExcel" />
                    <button type="submit" class="btn btn-sm btn-primary">
                        <img width="20px" height="20px" class="mr-1" src="../../assets/excel.png" />Export to Excel
                    </button>
                </form>
            </div>
        </div>
        <!-- /Pagination -->

        <!-- Result Empty -->
        <div class="mt-4" v-if="records && records.length == 0">
            <div class="col-12 no-record">
                {{ noRecordText }}
            </div>
        </div>

        <!-- Result -->
        <div class="row mt-2" v-if="records && records.length">
            <div class="col-md-12">
                <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
                    <table class="table table-bordered custom-table mb-0">
                        <thead class="thead-light">
                            <tr>
                                <th>Employee ID</th>
                                <th>Employee Name</th>
                                <th>Designation</th>
                                <th>Department</th>
                                <th>Job Grade</th>
                                <th>Cost Centre</th>
                                <th>Date Approved</th>
                                <th>Month/Year</th>
                                <th>Payable Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, i) in records" :key="i">
                                <td>{{ item.EmployeeID }}</td>
                                <td>{{ item.EmployeeName }}</td>
                                <td>{{ item.Designation }}</td>
                                <td>{{ item.Department }}</td>
                                <td>{{ item.JobGrade }}</td>
                                <td>{{ item.CostCentre }}</td>
                                <td>{{ item.ApprovedDateDisplay }}</td>
                                <td>{{ item.Month + "-" + item.Year }}</td>
                                <td>{{ item.PayableAmountDisplay }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!-- /Result -->

        <!-- Pagination -->
        <div class="row" v-if="records && records.length">
            <div class="col-md-6 col-lg-6 col-sm-6 my-auto text-lg-left text-center">
                Showing
                {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
                to
                {{
                        paging.CurrentPage * paging.SizePerPage -
                        paging.SizePerPage +
                        records.length
                }}
                of {{ totalRecords }} entries
            </div>

            <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
                <div class="navbar justify-content-end">
                    <button v-on:click="first()" v-if="paging.CurrentPage != 1" class="btn btn-white">
                        First
                    </button>
                    <button v-on:click="prev()" class="btn btn-white ml-1 mr-3" v-if="paging.CurrentPage > 1">
                        Prev
                    </button>
                    Page
                    <input class="form-control form-control-sm mx-1" type="number" step="1" min="1"
                        :max="paging.TotalPage" v-model="paging.CurrentPage" @change="onCurrentPageChange($event)"
                        style="width: 4rem" />

                    <span>of {{ paging.TotalPage }}</span>
                    <button v-on:click="next()" class="btn btn-white ml-3 mr-1"
                        v-if="paging.CurrentPage < paging.TotalPage">
                        Next
                    </button>
                    <button v-on:click="last()" v-if="paging.CurrentPage != paging.TotalPage" class="btn btn-white">
                        Last
                    </button>
                </div>
            </div>
        </div>
        <!-- /Pagination -->
    </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
import Select2 from "v-select2-component";

export default {
    components: { Select2 },
    data() {
        return {
            records: [],
            noRecordText: config.NO_RECORD_TEXT,
            //filter
            companies: [],
            company: config.DEFAULT_COMPANY,
            departments: [],
            department: "",
            approvedDateFrom: "",
            approvedDateTo: "",
            monthFrom: "",
            monthTo: "",
            years: [],
            yearFrom: "",
            yearTo: "",
            jobGrades: [],
            jobGrade: "",
            costCentres: [],
            costCentre: "",
            managers: [],
            managerId: "",
            designations: [],
            designation: "",
            employees: [],
            userId: "00000000-0000-0000-0000-000000000000",
            //for excel
            companyForExcel: "",
            departmentForExcel: "",
            approvedDateFromExcel: "",
            approvedDateToExcel: "",
            monthFromExcel: "",
            monthToExcel: "",
            yearFromExcel: "",
            yearToExcel: "",
            jobGradeExcel: "",
            costCentreExcel: "",
            managerIdExcel: "",
            designationExcel: "",
            userIdExcel: "",
            //pagination
            paging: {
                Search: "",
                CurrentPage: 1,
                TotalPage: "",
                SizePerPage: 20,
                Sizes: [5, 10, 20, 100],
                SortBy: "",
            },
            totalRecords: "",
        }
    },

    computed: {
        token() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Token;
        },
        role() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Role;
        },
        isManager() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.IsManager ? data.IsManager : false;
        },
        backendUrl() {
            return this.$backendUrl;
        },
    },

    watch: {
        "paging.SizePerPage": function (val, oldVal) {
            this.paging.CurrentPage = 1;
            this.search();
        },
        "paging.CurrentPage": function (val, oldVal) {
            if (val > this.paging.TotalPage) {
                this.paging.CurrentPage = this.paging.TotalPage;
            }
        },
        company(val) {
            if (this.isManager) this.getManagerEmployees(); else this.getEmployees();
        }
    },

    methods: {
        //filter
        getCompanies() {
            let param = {
                Token: this.token,
            };
            this.$store.state.isLoading = true;
            API.getCompanies(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.companies = response.data.record;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        getDepartments() {
            let param = {
                Token: this.token,
            };
            this.$store.state.isLoading = true;
            API.getDepartments(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.departments = response.data.record;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        getYears() {
            let param = { Token: this.token, IsActive: true };
            this.$store.state.isLoading = true;
            API.getYears(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.years = response.data.record;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        populateDateFilter() {
            //populate approved date from/to and claim month/year from/to with current month/year
            let currentDate = new Date();
            let currentMonth = currentDate.getMonth() + 1;
            let currentYear = currentDate.getFullYear();
            this.approvedDateFrom = `${currentYear}-${currentMonth}-01`;
            this.approvedDateTo = `${currentYear}-${currentMonth}-${new Date(currentYear, currentMonth, 0).getDate()}`;
            this.monthFrom = currentMonth;
            this.monthTo = currentMonth;
            this.yearFrom = currentYear;
            this.yearTo = currentYear;
        },
        getJobGrades() {
            let param = {
                Token: this.token,
            };
            this.$store.state.isLoading = true;
            API.getJobGrades(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.jobGrades = response.data.record;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        getCostCentres() {
            let param = {
                Token: this.token,
            };
            this.$store.state.isLoading = true;
            API.getCostCentres(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.costCentres = response.data.record;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        getManagers() {
            let param = {
                Token: this.token,
            };
            this.$store.state.isLoading = true;
            API.getManagers(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.managers = response.data.record;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        getDesignations() {
            let param = {
                Token: this.token,
            };
            this.$store.state.isLoading = true;
            API.getDesignations(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.designations = response.data.record;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        getEmployees() {
            let param = { Token: this.token, Company: this.company };
            this.$store.state.isLoading = true;
            API.getEmployees(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        response.data.record.unshift({ department: "", id: "00000000-0000-0000-0000-000000000000", text: "All" });
                        this.employees = response.data.record;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        getManagerEmployees() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            let param = { Token: this.token, IsActive: true, ManagerID: data.EmployeeID, Company: this.company };
            this.$store.state.isLoading = true;
            API.getManagerEmployees(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        response.data.record.unshift({ department: "", id: "00000000-0000-0000-0000-000000000000", text: "All" });
                        this.employees = response.data.record;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        getManagerEmployeeCompanies() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            let param = {
                Token: this.token,
                ManagerID: data.EmployeeID
            };
            this.$store.state.isLoading = true;
            API.getManagerEmployeeCompanies(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.companies = response.data.record;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        //action
        search() {
            //validation for claim month/year
            let yearFrom = parseInt(this.yearFrom);
            let yearTo = parseInt(this.yearTo);
            let monthFrom = parseInt(this.monthFrom);
            let monthTo = parseInt(this.monthTo);
            if (yearFrom == yearTo) {
                if (monthFrom > monthTo) {
                    alert("Car park claim Month/Year From cannot be greater than Car park claim Month/Year To.");
                    return;
                }
            } else if (yearFrom > yearTo) {
                alert("Car park claim Month/Year From cannot be greater than Car park claim Month/Year To.");
                return;
            }

            //store variable for export excel
            this.companyForExcel = this.company;
            this.departmentForExcel = this.department;
            this.approvedDateFromExcel = this.approvedDateFrom;
            this.approvedDateToExcel = this.approvedDateTo;
            this.monthFromExcel = this.monthFrom;
            this.monthToExcel = this.monthTo;
            this.yearFromExcel = this.yearFrom;
            this.yearToExcel = this.yearTo;
            this.jobGradeExcel = this.jobGrade;
            this.costCentreExcel = this.costCentre;
            this.managerIdExcel = this.managerId;
            this.designationExcel = this.designation;
            this.userIdExcel = this.userId;
            let param = {
                Token: this.token,
                Search: this.paging.Search,
                CurrentPage: this.paging.CurrentPage,
                TotalPage: this.paging.TotalPage,
                SizePerPage: this.paging.SizePerPage,
                SortBy: this.paging.SortBy,
                Company: this.company,
                Department: this.department,
                ApprovedDateFrom: this.approvedDateFrom,
                ApprovedDateTo: this.approvedDateTo,
                MonthFrom: this.monthFrom,
                MonthTo: this.monthTo,
                YearFrom: this.yearFrom,
                YearTo: this.yearTo,
                JobGrade: this.jobGrade,
                CostCentre: this.costCentre,
                ManagerId: this.managerId,
                Designation: this.designation,
                UserId: this.userId
            }
            this.$store.state.isLoading = true;
            API.getCarparkClaimReport(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.records = response.data.record;
                        this.totalRecords = response.data.total;
                        this.paging.TotalPage = response.data.pageCount;
                        if (this.paging.CurrentPage > this.paging.TotalPage) {
                            this.paging.CurrentPage = 1;
                        }
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        //pagination method
        onCurrentPageChange(event) {
            let currentPage = event.target.value;
            if (currentPage < 1) {
                currentPage = 1;
            }
            this.paging.CurrentPage = parseInt(currentPage);
            this.search();
        },
        first() {
            this.paging.CurrentPage = 1;
            this.search();
        },
        prev() {
            this.paging.CurrentPage -= 1;
            this.search();
        },
        next() {
            this.paging.CurrentPage += 1;
            this.search();
        },
        last() {
            this.paging.CurrentPage = this.paging.TotalPage;
            this.search();
        },
    },

    created() {
        if (this.role != "admin" && !this.isManager) {
            this.$router.replace({ name: "home" });
            return;
        }

        if (this.role == "admin") this.getCompanies(); else this.getManagerEmployeeCompanies();
        this.getDepartments();
        this.getYears();
        //this.populateDateFilter();
        this.getJobGrades();
        this.getCostCentres();
        this.getManagers();
        this.getDesignations();
        if (this.isManager) this.getManagerEmployees(); else this.getEmployees();
        //this.search();
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Carpark/MonthlyCarParkClaimReport.vue